export default __webpack_public_path__ + "static/media/teleperformance.f40e4bf6.svg";